import React, { FC, useState } from 'react';

import { FormattedMessage } from 'react-intl';

import { handleSpaceOrEnterPress } from '~/core/utils';

import { SelectorItem } from '../../styles';
import { GameInfo as GameInfoType, GameReports as GameReportsType, CommonGCGame } from '../../types';

import GameInfo from './components/gameInfo/GameInfo';
import GameReports from './components/gameReports/GameReports';

import { GameInfoReportHeader, GameInfoReportsContainer, InfoReportSelector } from './styles';

type Props = {
    game: CommonGCGame;
    gameInfo?: GameInfoType;
    gameReports?: GameReportsType;
};

enum InfoOrReports {
    GAME_REPORTS = 'gameReports',
    GAME_INFO = 'gameInfo',
}

const GameInfoText = (
    <FormattedMessage description="Header describing the game information box" defaultMessage="Game Info" />
);

const GameReportsText = (
    <FormattedMessage
        defaultMessage="Game Reports"
        description="A phrase that describes the different Game Reports. (Game Summary, Face-off Summary, Full Play-by-Play)"
    />
);

const GameInfoReports: FC<Props> = ({ game, gameInfo, gameReports }) => {
    const [visibleReport, setVisibleReport] = useState<InfoOrReports>(InfoOrReports.GAME_REPORTS);

    if (gameInfo && gameReports) {
        return (
            <GameInfoReportsContainer>
                <InfoReportSelector>
                    <SelectorItem
                        role="button"
                        tabIndex={0}
                        onClick={() => setVisibleReport(InfoOrReports.GAME_REPORTS)}
                        onKeyPress={(e) =>
                            handleSpaceOrEnterPress(e, () => setVisibleReport(InfoOrReports.GAME_REPORTS))
                        }
                        $isSelected={InfoOrReports.GAME_REPORTS === visibleReport}
                    >
                        {GameReportsText}
                    </SelectorItem>
                    <SelectorItem
                        role="button"
                        tabIndex={0}
                        onClick={() => setVisibleReport(InfoOrReports.GAME_INFO)}
                        onKeyPress={(e) => handleSpaceOrEnterPress(e, () => setVisibleReport(InfoOrReports.GAME_INFO))}
                        $isSelected={InfoOrReports.GAME_INFO === visibleReport}
                    >
                        {GameInfoText}
                    </SelectorItem>
                </InfoReportSelector>
                {visibleReport === InfoOrReports.GAME_INFO ? (
                    <GameInfo game={game} gameInfo={gameInfo} />
                ) : (
                    <GameReports game={game} reports={gameReports} />
                )}
            </GameInfoReportsContainer>
        );
    } else if (gameInfo) {
        return (
            <GameInfoReportsContainer>
                <GameInfoReportHeader role="heading" aria-level={2}>
                    {GameInfoText}
                </GameInfoReportHeader>
                <GameInfo game={game} gameInfo={gameInfo} />
            </GameInfoReportsContainer>
        );
    } else if (gameReports) {
        return (
            <GameInfoReportsContainer>
                <GameInfoReportHeader role="heading" aria-level={2}>
                    {GameReportsText}
                </GameInfoReportHeader>
                <GameReports game={game} reports={gameReports} />
            </GameInfoReportsContainer>
        );
    }
    return null;
};

export default GameInfoReports;
